module.exports = __webpack_public_path__ + "static/WEDDING E&M-520-56f1a046f9a0e0cac3ce888732b7a331.jpg";